// @flow

import React from 'react'

type PropTypes = {
  onClick: Function,
}

export default (props: PropTypes) => (
  <div className="site-header__search-sm pc-hide__sm-show">
    <div className="sm__site-header__search">
      <div className="sm__site-header__search-bd">
        <div className="site-header__search-input-wrapper">
          <input
            type="search"
            onClick={props.onClick}
            readOnly
            value=""
            className="site-header__search-input site-header__search-keyword"
            placeholder="何を？ どこで？ いつ？"
          />
          <a
            href="#"
            className="js-mobile-header-search__tranparent"
            onClick={props.onClick}
          />
        </div>
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/organisms/SearchHeader/index.jsx